import { Component, Input, OnChanges, OnInit, OnDestroy, Inject } from '@angular/core';
import { ISearchCars, ITopCars } from 'src/app/model/http/cars.model';
import { IImagesJato } from 'src/app/model/http/images.model';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';
import { SummaryService } from 'src/app/services/summary.service';
import { WINDOW } from 'src/app/utils/window';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-images-presenter',
  templateUrl: `./images-presenter.component${environment.templateSuffix}.html`,
  styleUrls: ['./images-presenter.component.scss']
})
export class ImagesPresenterComponent implements OnChanges, OnInit, OnDestroy {
  @Input() car!: ITopCars | ISearchCars;
  @Input() images!: IImagesJato;
  mainImageUrl: any
  showcarousel: boolean = false;


  screenSize = this.window.innerWidth;
  subscriptionScreen!: Subscription;

  constructor(
    private dataService: DataService,
    public summaryService: SummaryService,
    @Inject(WINDOW) private window: Window
  ) { }

  ngOnInit(): void {

    this.subscriptionScreen = this.dataService.getScreenSize().subscribe( resp => this.screenSize = resp );
  }

  ngOnChanges(changes: any): void {
    this.showcarousel = false
    this.mainImageUrl = this.images.imagenes[0]
    setTimeout(() => {
      this.showcarousel = true
    }, 500);
  }

  ngOnDestroy(): void {
      this.subscriptionScreen.unsubscribe();
  }

  setMainImg(url: string) {
    this.mainImageUrl = url;
  }

}
